import React from "react";

interface CustomButtonProps {
  color?: {
    buttonColor?: string;
    textColor?: string;
  };
  text: string;
  disabled?: boolean;
  // onClick?: () => void;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  buttonStyle?: "primary" | "secondary";
  type?: "button" | "submit" | "reset"; // Make 'type' optional
}

const CustomButton: React.FC<CustomButtonProps> = ({
  color = {
    buttonColor: "bg-gray-800",
    textColor: "text-white",
  },
  text,
  disabled = false,
  className,
  onClick,
  type = "button",
  buttonStyle = "primary",
}) => {
  let { buttonColor, textColor } = color;
  let secondaryButtonClasses;
  if (buttonStyle === "secondary") {
    buttonColor = "bg-white";
    textColor = "text-black";
    secondaryButtonClasses =
      "border border-solid border-gray-800 hover:bg-white";
  }

  return (
    <button
      type={type}
      className={`px-4 py-2 rounded-custom-10 font-590 ${secondaryButtonClasses} ${className} ${buttonColor} ${textColor} ${disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-900"
        } `}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default CustomButton;
